import styled from 'styled-components';

export const MessageContainer = styled.div`
  padding-block-end: 1rem;
  background-color: ${Styles.color.white};
`;
